import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()
const usePre = publicRuntimeConfig.VEND_IDENTITY === 'PRE'

export const VEND_PROFILE_URL = usePre
  ? 'https://account.pre.identity.m10s.io'
  : 'https://account.vend.se'

export const VEND_PRIVACY_SETTINGS_URL = usePre
  ? 'https://privacysettings-pre-se.schibsted.io' // should not be changed yet to Vend according to docs
  : 'https://privacysettings.vend.se'

export const VEND_CLIENT_ID = usePre ? '618ce9063786d16a8e56cb77' : '54fdbd1aa24e7b191d360df8'
